/** "unknown" loading state */
export default 0;
